export default __webpack_public_path__ + "static/media/2B_360_1.212f1906.jpg";